module.exports = __webpack_public_path__ + "static/media/img_job_mobile.e995127c.png";